import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectAddStatus, selectItems } from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";
import {
    myTasksAuditFilesListName,
    myTasksAuditListName,
    myTasksAuditQuestionsListName,
} from "src/api/config/myTasksAudit.config";
import {
    myTasksDependListName,
    myTasksLocationsListName,
} from "src/api/config/myTasksLists.config";
import { getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "src/api/requests/updateFile";
import { useSearchParams } from "react-router-dom";
import { MTAuditFiles } from "src/api/config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { autoCloseModal } from "src/constants";

const taskCardButtonClassName =
  "block w-full bg-transparent px-[28px] py-[16px] text-center font-normal leading-none tracking-normal text-darkblue hover:bg-[#F4F6FC]";

const AddAudit = ({ zIndex, fromTaskCard = false }: { zIndex: number, fromTaskCard?: boolean }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [open, setOpen] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [addAudit, setAddAudit] = useState(false);
    const [closeAllModals, setCloseAllModals] = useState(false);
    const [fields, setFields] = useState<any>([
        {
            type: 'date',
            require: true,
            key: 'DateOb',
            title: 'Дата наблюдения',
            minDate: moment(new Date()).subtract(7, 'days').toDate(),
            maxDate: moment(new Date()).toDate(),
            placeholder: 'дд.мм.гггг',
            width: 'w-full'
        },
        {
            type: 'peoplePicker',
            require: true,
            single: true,
            key: 'Observer',
            title: 'ФИО наблюдателя',
            current: true,
            placeholder: 'Введите имя или фамилию',
            width: 'w-full'
        },
        {
            type: 'select',
            require: true,
            title: 'Сотрудник, за кем проводили наблюдение',
            key: 'ObservedType',
            placeholder: 'Выберите из списка',
            width: 'w-full'
        },
        {
            type: 'peoplePicker',
            require: true,
            single: true,
            key: 'ObservedUser',
            title: 'ФИО, за кем проводили наблюдение',
            current: false,
            placeholder: 'Введите имя или фамилию',
            width: 'w-full'
        },
        {
            type: 'input',
            require: true,
            hide: true,
            key: 'ObservedString',
            title: 'ФИО, за кем проводили наблюдение',
            placeholder: 'Введите имя или фамилию',
            width: 'w-full'
        },
        {
            type: 'select',
            require: true,
            key: 'Location',
            title: 'Локация, где проводилось наблюдение',
            placeholder: 'Не выбрано',
            width: 'w-full'
        },
        {
            type: 'select',
            require: true,
            key: 'Department',
            title: 'Отдел, где проводилось наблюдение',
            placeholder: 'Не выбрано',
            width: 'w-full'
        },
        {
            type: 'select',
            require: true,
            key: 'Region',
            title: 'Участок, где проводилось наблюдение',
            placeholder: 'Не выбрано',
            width: 'w-full'
        }
    ]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null,
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({
        DateOb: {
            startDate: new Date(),
            endDate: new Date(),
        },
        ObservedType: {
            id: 1,
            name: "Внутренний",
        },
    });

    const users: any = useAppSelector(selectUsers);
    const statusAddAction = useAppSelector((state) =>
        selectAddStatus(state, myTasksAuditListName)
    );

    const [customLoading, setCustomLoading] = useState(true);
    const [auditQuestions, setAuditQuestions] = useState<any>([]);

    const locations: any = useAppSelector((state) =>
        selectItems(state, myTasksLocationsListName)
    );
    const dependencies: any = useAppSelector((state) =>
        selectItems(state, myTasksDependListName)
    );
    const [observedType, setObservedType] = useState("");
    const [auditIDAdd, setAuditIDAdd] = useState<any>(null);
    const [query, setQuery] = useSearchParams();
    const [renderAudit, setRenderAudit] = useState(false);
    const [auditKeys, setAuditKeys] = useState<any>([]);
    const [currentFormData, setCurrentFormData] = useState<any>(null);
    const [createAuditID, setCreateAuditID] = useState<any>(0);
    const [removeAudit, setRemoveAudit] = useState(false);


    //Расставляем опции селектов локации, типа сотрудников
    useEffect(() => {
        if (currentUser.id && renderAudit) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Location") {
                    const options = locations.filter((location: any) => {
                        if (
                        currentUser.isAdmin ||
                        (currentUser.isLocationEditorMyTasks &&
                            currentUser.isLocationEditorMyTasks.length > 0 &&
                            currentUser.isLocationEditorMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            )) ||
                        (currentUser.isLocationAdminMyTasks &&
                            currentUser.isLocationAdminMyTasks.length > 0 &&
                            currentUser.isLocationAdminMyTasks.find(
                            (locationID: any) => locationID === location.ID
                            ))
                        ) {
                        return true
                        } else {
                        return false
                        }
                    }).map((location: any) => {
                        return {
                        id: location.ID,
                        name: location.Title,
                        available: true,
                        };
                    });
                    tempFieldsForm[i]["options"] = [...options];
                }
                if (tempFieldsForm[i]["key"] === "ObservedType") {
                    tempFieldsForm[i]["options"] = [
                        {
                            id: 1,
                            name: "Внутренний",
                        },
                        {
                            id: 0,
                            name: "Внешний",
                        },
                    ];
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (locations.length > 0 && currentUser.id) {
            let defaultLocationsIds: number[] = [];
            if (
                currentUser.isLocationAdminMyTasks ||
                currentUser.isLocationEditorMyTasks
            ) {
                if (
                    Array.isArray(currentUser.isLocationAdminMyTasks) &&
                    currentUser.isLocationAdminMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationAdminMyTasks,
                    ];
                }
                if (
                    Array.isArray(currentUser.isLocationEditorMyTasks) &&
                    currentUser.isLocationEditorMyTasks.length > 0
                ) {
                    defaultLocationsIds = [
                        ...defaultLocationsIds,
                        ...currentUser.isLocationEditorMyTasks,
                    ];
                }
            }
            let unicDefaultLocationsIds: number[] = [
                ..._.uniqWith(defaultLocationsIds, _.isEqual),
            ];
            setDefaultValues((prev) => {
                return {
                    ...prev,
                    Location:
                        (unicDefaultLocationsIds.length > 0 &&
                            unicDefaultLocationsIds.map((id) => {
                                return {
                                    id: id,
                                    name: locations.find((location: any) => location.ID === id)[
                                        "Title"
                                        ],
                                    disabled: false,
                                };
                            })[0]) ||
                        null,
                };
            });
        }
    }, [locations, currentUser, renderAudit]);

    useEffect(() => {
        if (dependenceFields["Location"] && renderAudit) {
            dispatch(
                getItems({
                    listName: myTasksDependListName,
                    filters: { Location: dependenceFields["Location"]["id"] },
                })
            );
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    tempFieldsForm[i]["disabled"] = false;
                }
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (!dependenceFields["Location"] && renderAudit) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (
                    tempFieldsForm[i]["key"] === "Department" ||
                    tempFieldsForm[i]["key"] === "Region"
                ) {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (dependenceFields["Department"] && renderAudit) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = false;
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependenceFields, renderAudit]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

    useEffect(() => {
        if (renderAudit) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (dependenceFields["Location"]) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        const options = dependencies
                            .filter(
                                (dependence: any) =>
                                    dependence.Location.ID === dependenceFields["Location"]["id"]
                            )
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Departament.ID,
                                    name: dependence.Departament.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
                if (dependenceFields["Department"]) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        const options = dependencies
                            .filter(
                                (dependence: any) =>
                                    dependence.Location.ID ===
                                    dependenceFields["Location"]["id"] &&
                                    dependence.Departament.ID ===
                                    dependenceFields["Department"]["id"]
                            )
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Region.ID,
                                    name: dependence.Region.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependencies, renderAudit]);

    useEffect(() => {
        setOpen(false);
        setCancel(false);
        setAddAudit(false);
    }, [closeAllModals]);

    useEffect(() => {
        if (statusAddAction === "SUCCESS") {
            setOpen(false);
            setCancel(false);
            setFormData(null);
        }
    }, [statusAddAction]);

  useEffect(() => {
    if (open) {
      const sendData = {
        Title: `Временный поведенческий аудит`,
        Hide: 1
      };
      addItemRequest({ listName: myTasksAuditListName, body: sendData }).then(
        (auditID) => {
          console.log('Создали аудит #: ', auditID);
          setCreateAuditID(auditID);
        });
    }
  }, [open]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            console.log("FORM_DATA_AUDIT: ", formData);
            setCustomLoading(true);
            let tempAuditObj: any = {};
            Object.keys(formData).map((key) => {
                if (auditKeys.some((auditKey: string) => auditKey === key)) {
                    if (Array.isArray(formData[key])) {
                        formData[key].sort((a: any, b: any) => {
                            return a.localeCompare(b);
                        });
                        tempAuditObj[key] = formData[key];
                    } else {
                        tempAuditObj[key] = formData[key];
                    }
                }
            });
            const sendData = {
                Audit: JSON.stringify(tempAuditObj),
                Title: `Поведенческий аудит от ${moment(
                    (typeof formData.DateOb.startDate === "string" &&
                        new Date(formData.DateOb.startDate)) ||
                    formData.DateOb.startDate
                ).format("DD.MM.YYYY")}`,
                DateOb:
                    (typeof formData.DateOb.startDate === "string" &&
                        new Date(formData.DateOb.startDate)) ||
                    formData.DateOb.startDate,
                Observer: formData.Observer[0]["value"],
                ObserverDepartment:
                    (users[formData.Observer[0]["value"]] &&
                        users[formData.Observer[0]["value"]]["department"]) ||
                    "",
                ObserverEmail: formData.Observer[0]["value"],
                ObservedType: formData.ObservedType.name,
                ObservedUser:
                    formData.ObservedUser && formData.ObservedUser[0]["value"],
                ObservedUserEmail:
                    formData.ObservedUser && formData.ObservedUser[0]["value"],
                ObservedString: formData.ObservedString,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Description: formData.Description.trim() + " ",
                Feedback: formData.Feedback && formData.Feedback.trim() + " ",
                AuthorEmail: currentUser.email,
                ID: createAuditID
            };
            updateItemRequest({ listName: myTasksAuditListName, body: sendData }).then(
                (auditID) => {
                    setAuditIDAdd(auditID);
                    let uploadAuditFilesRequests: any = [];
                    formData.AuditFiles &&
                    formData.AuditFiles.length > 0 &&
                    formData.AuditFiles.forEach((file: any) => {
                        uploadAuditFilesRequests = [
                            ...uploadAuditFilesRequests,
                            uploadFile(
                                file,
                                myTasksAuditFilesListName,
                                MTAuditFiles.idFolder,
                                MTAuditFiles.apiStrapi,
                                MTAuditFiles.createElemInStrapi
                            ),
                        ];
                    });
                    if (uploadAuditFilesRequests.length > 0) {
                        Promise.all(uploadAuditFilesRequests).then((values: any) => {
                            let idsAuditFiles: number[] = [];
                            values.length > 0 &&
                            values.forEach((value: any) => {
                                idsAuditFiles = [...idsAuditFiles, value.id];
                            });
                            if (idsAuditFiles.length > 0) {
                                let updateAuditFilesRequests: any = [];
                                idsAuditFiles.forEach((idFile: number) => {
                                    updateAuditFilesRequests = [
                                        ...updateAuditFilesRequests,
                                        updateFile(
                                            myTasksAuditFilesListName,
                                            { Audit: auditID, ID: idFile },
                                            MTAuditFiles.apiStrapi,
                                            { Audit: auditID, id: idFile }
                                        ),
                                    ];
                                });
                                if (updateAuditFilesRequests.length > 0) {
                                    Promise.all(updateAuditFilesRequests).then(() => {
                                        setCustomLoading(false);
                                        setAddAudit(true);
                                    });
                                }
                            }
                        });
                    } else {
                        setCustomLoading(false);
                        setAddAudit(true);
                    }
                }
            );
        }
    }, [formData]);

    useEffect(() => {
        if (auditQuestions.length > 0) {
            setFields((prevState: []) => [...prevState, ...auditQuestions]);
            setRenderAudit(true);
        }
    }, [auditQuestions]);

    useEffect(() => {
        getItemsRequest({
            listName: myTasksAuditQuestionsListName,
            sortOrder: { name: "SortColumn", asc: true },
        }).then((results) => {
            const tempAuditQuestions = [...results.items];
            let auditKeys: string[] = [];
            let auditFieldsForm: any = [];
            tempAuditQuestions.forEach((item) => {
                auditFieldsForm = [
                    ...auditFieldsForm,
                    {
                        type: item.TypeQuestion,
                        require: item.Require,
                        single: true,
                        current: false,
                        key: item.dc0t,
                        title: item.Title,
                        hide: item.DefaultHide,
                        notice: item.Notice,
                        noticeIcon: (item.Notice && true) || false,
                        width: "w-full",
                        optionsInputs:
                            (item.Options &&
                                item.Options.split(";").map((option) => option.trim())) ||
                            [],
                        condition: item.Condition && JSON.parse(item.Condition),
                    },
                ];
                auditKeys = [...auditKeys, item.dc0t];
            });
            auditFieldsForm = [
                ...auditFieldsForm,
                ...[
                    {
                        type: "textArea",
                        key: "Description",
                        require: true,
                        title: "Описание",
                        placeholder:
                            "Опишите операцию/процесс/действие, за которой(ым) проводилось наблюдение",
                        width: "w-full",
                    },
                    {
                        type: "textArea",
                        key: "Feedback",
                        require: false,
                        title: "Обратная связь от человека, за которым наблюдали",
                        placeholder: "Введите описание",
                        width: "w-full",
                    },
                    {
                        type: "file",
                        key: "AuditFiles",
                        multiple: true,
                        require: false,
                        width: "w-full",
                        title: "Перетащите документ сюда или",
                        titleFile: "выберите файл",
                        placeholder: "Размер файла не более 50MB",
                    },
                ],
            ];
            setAuditKeys([...auditKeys]);
            setAuditQuestions([...auditFieldsForm]);
            setCustomLoading(false);
        });
    }, []);

    useEffect(() => {
        if (observedType && renderAudit) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (observedType === "Внутренний") {
                    if (tempFieldsForm[i]["key"] === "ObservedUser") {
                        tempFieldsForm[i]["hide"] = false;
                        tempFieldsForm[i]["require"] = true;
                    }
                    if (tempFieldsForm[i]["key"] === "ObservedString") {
                        tempFieldsForm[i]["hide"] = true;
                        tempFieldsForm[i]["require"] = false;
                    }
                }
                if (observedType === "Внешний") {
                    if (tempFieldsForm[i]["key"] === "ObservedUser") {
                        tempFieldsForm[i]["hide"] = true;
                        tempFieldsForm[i]["require"] = false;
                    }
                    if (tempFieldsForm[i]["key"] === "ObservedString") {
                        tempFieldsForm[i]["hide"] = false;
                        tempFieldsForm[i]["require"] = true;
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [observedType, renderAudit]);

    useEffect(() => {
        if (renderAudit && currentFormData) {
            console.log("currentFormData: ", currentFormData);
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (field.condition) {
                    let conditionObj: any = {};
                    Object.keys(field.condition).map((key: string) => {
                        if (typeof currentFormData[key] === "object") {
                            if (currentFormData[key]["name"] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        } else {
                            if (currentFormData[key] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        }
                    });
                    if (
                        Object.keys(field.condition).length ===
                        Object.keys(conditionObj).length
                    ) {
                        tempFieldsForm[i]["hide"] = false;
                    } else {
                        tempFieldsForm[i]["hide"] = true;
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [currentFormData, renderAudit]);

    useEffect(() => {
        if (!addAudit && auditIDAdd) {
            localStorage.setItem("NEW_AUDIT", auditIDAdd.toString());
            setAuditIDAdd(null);
            const newSearchParams = new URLSearchParams(query);
            newSearchParams.set("auditCardMobile", auditIDAdd.toString());
            setQuery(newSearchParams);
        }
    }, [addAudit]);

    useEffect(() => {
      if (cancel) {
        setRemoveAudit(true)
      }
      if (!cancel && removeAudit) {
        deleteItemRequest({ listName: myTasksAuditListName, ID: createAuditID }).then(() => {
          getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#ПоведенческийАудит_${createAuditID}` } }).then(results => {
            const actions = [...results.items];
            const actionIds = actions.map(action => {
              return { ID: action.ID }
            });
            deleteItemRequest({ listName: myTaskActionsListName, ID: 0, Ids: actionIds }).then(() => {
              console.log('Удалили аудит #: ', createAuditID);
              setCreateAuditID(0);
              setRemoveAudit(false);
            });
          })
        });
      }
    }, [cancel]);


    return (
        <>
            {fromTaskCard ? (
                    <button type="button" className={`${taskCardButtonClassName} `} onClick={() => setOpen(true)}>
                      Поведенческий аудит
                    </button>
                  ) : (
                    <Button open={open} setOpen={setOpen} typeIcon="add" classBg="btn-dark" text="Создать новую форму" icon={true} />
                  )}

            <DrawerComponent setOpenCustomModal={setCancel} zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                <div className="flex flex-col p-[24px] shrink">
                    <h1 className="mb-8 text-black text-[16px] leading-[110%]">Создание формы поведенческого аудита</h1>
                    {((statusAddAction === "LOADING" || customLoading) && (
                        <div className="flex items-center justify-center w-full mt-5 mb-5">
                            <Loading />
                        </div>
                    )) || (
                            <Form
                                type="add_my_tasks_audit"
                                setFormData={setFormData}
                                fieldsForm={[...fields]}
                                setOpenCancelAddCard={setCancel}
                                openCancelAddCard={cancel}
                                defaultValues={defaultValues}
                                setDependenceFields={setDependenceFields}
                                setCurrentFormData={setCurrentFormData}
                                setObservedType={setObservedType}
                                auditID={createAuditID}
                                isMobileModeAddInComponent={true}
                            />
                        )}
                </div>
            </DrawerComponent>

            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={cancel} toggleDialog={setCancel}>
                <header className="px-10 pb-4">
                    <h2>Вы действительно хотите отменить изменения?</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        При нажатии на “Отмена” возврат действий будет невозможен
                    </p>
                </div>

                <footer className="flex flex-col gap-2 w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setCancel(false)}>
                        Закрыть
                    </TGButton>
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Подтвердить отмену
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px"
                open={addAudit}
                toggleDialog={setAddAudit}
                autoClose={autoCloseModal}
                onAutoClose={() => {
                    setCloseAllModals(!closeAllModals);
                }}
            >
                <header className="px-10 pb-4">
                    <h2>Вы успешно сохранили форму</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Форма сохранена со всеми изменениями
                    </p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
        </>
    );
};

export default AddAudit;
